<section class="main-section form-section">
  <form>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="inner-box">
          <h2>Package Configuration</h2>
          <div class="row">
            <div class="col">
              <table class="table">
                <thead>
                <tr>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let r of packageList">
                  <td>{{r.config}}</td>
                  <td>
                    <a data-toggle="modal" data-target="#deleteReturnModal1" (click)="selectedDeletePackage(r)"
                       class="p-2 ml-3">
                      <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                        <defs><style>.a{fill:#848484;}</style></defs>
                        <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                      </svg>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="text" id="config" [(ngModel)]="config" class="form-control" [ngModelOptions]="{standalone: true}" required></td>
                  <td>
                    <button class="btn btn-outline-primary btn-sm" (click)="submitPackage()">
                      <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                        <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                      </svg>
                      Add
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div id="statusText1" class="invalid-feedback d-block shift-invalid-login mt-2"
                   [hidden]="!statusText1">{{statusText1}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="inner-box">
          <h2>Pricing Configuration</h2>
        </div>
        </div>
        </div>
  </form>
</section>
<!--Delete model-box One-->
<div class="container">
  <div class="modal fade" id="deleteReturnModal1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deletePackage()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Delete model-box two-->
<div class="container">
  <div class="modal fade" id="deleteReturnModal2" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
